import type {BaseComponentConfig} from "@gamzix/slot_core";

class gameMachineComponent extends SlotGame.src.component.BaseComponent {

    constructor(config: BaseComponentConfig) {
        super(config);
    }
}

//@ts-ignore
Game.src.component.gameMachineComponent = gameMachineComponent;
